import { useTranslation } from 'react-i18next';

const programs = [
  {
    key: 'charity',
    icon: 'ri-hand-heart-line',
    image:
      'https://readdy.ai/api/search-image?query=Caring%20hands%20giving%20a%20box%20of%20fresh%20groceries%20and%20rice%20to%20a%20grateful%20elderly%20person%2C%20warm%20natural%20light%2C%20soft%20emerald%20green%20background%2C%20documentary%20charity%20photography%2C%20compassionate%20hopeful%20mood%2C%20high%20detail&width=800&height=600&seq=nur-charity-01&orientation=landscape',
  },
  {
    key: 'donation',
    icon: 'ri-gift-2-line',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20packed%20donation%20boxes%20with%20clothes%20rice%20and%20essentials%2C%20warm%20amber%20and%20green%20tones%2C%20soft%20studio%20light%20on%20warm%20beige%20background%2C%20editorial%20product%20photography%2C%20generous%20giving%20mood%2C%20clean%20composition&width=800&height=600&seq=nur-donation-01&orientation=landscape',
  },
  {
    key: 'training',
    icon: 'ri-graduation-cap-line',
    image:
      'https://readdy.ai/api/search-image?query=Group%20of%20enthusiastic%20adults%20learning%20sewing%20skills%20at%20a%20bright%20community%20workshop%2C%20colorful%20fabric%20and%20sewing%20machines%20on%20wooden%20tables%2C%20warm%20natural%20light%2C%20emerald%20and%20amber%20accents%2C%20documentary%20photography%2C%20empowering%20educational%20mood&width=800&height=600&seq=nur-training-01&orientation=landscape',
  },
];

export default function Programs() {
  const { t } = useTranslation();

  return (
    <section id="programs" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold uppercase tracking-wide">
            {t('programs.tag')}
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            {t('programs.title')}
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-foreground-600">
            {t('programs.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {programs.map((p) => (
            <article
              key={p.key}
              className="rounded-lg border border-background-200 bg-white overflow-hidden flex flex-col group hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={p.image}
                  alt={t(`programs.${p.key}.title`)}
                  title={`Insani Darul Hana ${t(`programs.${p.key}.title`)}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 text-primary-600 text-lg">
                  <i className={p.icon}></i>
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
                  {t(`programs.${p.key}.title`)}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">
                  {t(`programs.${p.key}.desc`)}
                </p>
                <a
                  href="#contact"
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
                >
                  {t('programs.learnMore')}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}